import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Grid, styled } from "@mui/material"
import { useAppDispatch } from "redux/hooks"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  isProtected?: boolean
}

const FooterComponent = ({ isProtected, ...restProps }: Props) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const ITEMS = [
    {
      link: isProtected ? "/pages/terms" : "/terms",
      title: t("menu.terms"),
    },
    {
      link: isProtected ? "/pages/privacy" : "/privacy",
      title: t("menu.privacy"),
    },
    {
      link: isProtected ? "/pages/cookie" : "/cookie",
      title: t("menu.cookie"),
    },
  ]

  const handleResetPoling = () => {
    dispatch(resetPolling())
  }

  return (
    <Footer container {...restProps}>
      {ITEMS.map(({ link, title }, index: number) => (
        <Item onClick={handleResetPoling} key={index} to={link}>
          {title}
        </Item>
      ))}
    </Footer>
  )
}

FooterComponent.defaultProps = {
  isProtected: false,
}

export default FooterComponent

const Footer = styled(Grid)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  margin: "50px 0",
  [theme.breakpoints.down("md")]: {
    justifyContent: "space-around",
  },
  [theme.breakpoints.down("sm")]: {
    justifyContent: "space-between",
  },
}))

const Item = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: "0.875rem",
  fontWeight: "500",
  lineHeight: "15px",
  margin: "0 32px",
  textDecoration: "none",
  [theme.breakpoints.down("md")]: {
    margin: "0",
  },
}))
